import { render, staticRenderFns } from "./deleteComplaint.vue?vue&type=template&id=2c5558a1"
import script from "./deleteComplaint.vue?vue&type=script&lang=js"
export * from "./deleteComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports